if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.quantity = this.querySelector('input[name="quantity"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);

        if (!formData.get("quantity") && this.quantity) {
          const qty_val = this.quantity.value;
          formData.append("quantity", qty_val);
        }

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        const productVariantId = formData.get("id");
        const isFreeAdded = window.freeProducts && window.freeProducts.length > 0 ? await fetch("/cart.js")
          .then((response) => {
            return response.json();
          })
          .then((cart) => {
            if (!window.freeProducts || !Array.isArray(window.freeProducts)) {
              return false;
            }
            try {
              return cart.items.some((item) =>
                window.freeProducts.includes(item.variant_id)
              );
            } catch (error) {
              return false;
            }
          
          })
          .catch((error) => {
            console.error("Error fetching cart:", error);
          }) : false;

        const isFreeProduct =window.freeProducts && window.freeProducts.length > 0 ? window.freeProducts.includes(
          parseInt(productVariantId)
        ) : false;
        if (isFreeAdded && isFreeProduct) {
          this.submitButton.classList.remove("loading");
          this.submitButton.removeAttribute("aria-disabled");
          this.querySelector(".loading-overlay__spinner").classList.add(
            "hidden"
          );
        
          this.handleErrorMessage("Free product has already been added to the cart");
          return;
        }

         /* Sample Product JS */
        if(window.sampleProducts.includes(parseInt(productVariantId))){
       // const isSampleAdded =  window.sampleProducts.length > 0 ? await fetch("/cart.js")
       //    .then((response) => {
       //      return response.json();
       //    })
       //    .then((cart) => {
       //      if (!window.sampleProducts || !Array.isArray(window.sampleProducts)) {
       //        return false;
       //      }
       //      try {
       //        const sampleCount = cart.items.filter((item) =>
       //          window.sampleProducts.includes(item.variant_id)
       //        ).length;
       //        return sampleCount > 2;
       //      } catch (error) {
       //        return false;
       //      }
          
       //    })
       //    .catch((error) => {
       //      console.error("Error fetching cart:", error);
       //    }) : false;

         const isSampleProduct =window.sampleProducts && window.sampleProducts.length > 0 ? window.sampleProducts.includes(
           parseInt(productVariantId)
         ) : false;

        const isSampleProductAdded = await fetch("/cart.js")
          .then((response) => {
            return response.json();
          })
          .then((cart) => {
            return cart.items.some((item) => item.variant_id === parseInt(productVariantId));          
          })
          .catch((error) => {
            console.error("Error fetching cart:", error);
            return false;
          }) 
       
        if (isSampleProductAdded) {
          
          this.submitButton.classList.remove("loading");
          this.submitButton.removeAttribute("aria-disabled");
          this.querySelector(".loading-overlay__spinner").classList.add(
            "hidden"
          );
        
          this.handleErrorMessage("The product is already in your cart");
          return;
        }
        // if (isSampleAdded) {
          
        //   this.submitButton.classList.remove("loading");
        //   this.submitButton.removeAttribute("aria-disabled");
        //   this.querySelector(".loading-overlay__spinner").classList.add(
        //     "hidden"
        //   );
        
        //   this.handleErrorMessage("Sample product limit has reached");
        //   return;
        // }
        }
      /* Sample Product JS */
        
        try {
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: "product-form",
                  productVariantId: productVariantId,
                  errors: response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage =
                  this.submitButton.querySelector(".sold-out-message");
                if (!soldOutMessage) return;
                this.submitButton.setAttribute("aria-disabled", true);
                this.submitButton.querySelector("span").classList.add("hidden");
                soldOutMessage.classList.remove("hidden");
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "product-form",
                  productVariantId: productVariantId,
                });
              this.error = false;
              const quickAddModal = this.closest("quick-add-modal");
              if (quickAddModal) {
                document.body.addEventListener(
                  "modalClosed",
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove("loading");
              if (this.cart && this.cart.classList.contains("is-empty"))
                this.cart.classList.remove("is-empty");
              if (!this.error)
                this.submitButton.removeAttribute("aria-disabled");
              this.querySelector(".loading-overlay__spinner").classList.add(
                "hidden"
              );
            });
        } catch (error) {
          console.error("Fetch error:", error);
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

class stickyCartModal extends HTMLElement {
  constructor() {
    super();
    window.addEventListener("scroll", this.update.bind(this));
    this.update();
    document
      .querySelector("footer")
      .classList.add("sticky-cart-modal_bottom_padding");
  }
  update() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const rangeToShowModal = this.getTop(addButton) + button.clientHeight;
    if (
      window.scrollY >= rangeToShowModal &&
      !this.classList.contains("show-modal")
    ) {
      this.classList.add("show-modal");
      document.querySelector("body").classList.add("modal__sticky-cart");
    }
    if (
      window.scrollY < rangeToShowModal &&
      this.classList.contains("show-modal")
    ) {
      this.classList.remove("show-modal");
      document.querySelector("body").classList.remove("modal__sticky-cart");
    }
  }
  getTop(el) {
    return el.offsetTop + (el.offsetParent && this.getTop(el.offsetParent));
  }
}
customElements.define("sticky-cart-modal", stickyCartModal);
